import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const ReportBuilderResults = lazy(() =>
  import("@scenes/ReportBuilder2/ReportBuilder2Results/ReportBuilder2Results").then((module) => ({
    default: module.ReportBuilder2Results,
  }))
);

export const reportBuilder2ResultsNRO: NavigationRoutingObject = {
  section: "analytics",
  Component: ReportBuilderResults,
  componentFeatureFlippers: [],
  heading: (t: I18nT<"dashboard-navigation">) => t("report-builder-2-results-nro-heading", "Report"),
  pageNameForTracking: () => "Report",
  tag: "beta",
  getDeveloperNavigationAllowed: ({ isImpersonating, hasPermission }) => {
    const userHasViewReportingPermission = hasPermission("appGroupOrAnyTeamInAppGroup", {
      permission: "viewReporting",
    });
    return isImpersonating || userHasViewReportingPermission;
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/dashboard/report_builder_2/:appGroupId",
  noKnockoutFallback: true,
};
